import styled from '@emotion/styled';
import tw from 'twin.macro';
import { Content as TooltipContent } from '@/components/Tooltip/Tooltip.styles';
import Link from '@/components/Link/Link';

export const StyledLink = styled(Link)`
  ${tw`block`}
  ${tw`w-fit`}

  // Hide text nodes but keep images visible
  ${tw`text-[0px]`}
  ${tw`leading-[0px]`}
`;

export const StyledTooltipContent = styled(TooltipContent)`
  &.tooltip {
    ${tw`font-semi-bold`}
    ${tw`text-tag-s text-center`}
    ${tw`tracking-[1.2px]`}
    ${tw`rounded-full`}
    ${tw`px-[14px] py-[9px]`}

    /* Hide tooltip during initial positioning */
    &:not(.react-tooltip__show) {
      opacity: 0 !important;
      visibility: hidden;
    }
  }
`;

export const StyledIconWithoutLink = styled.div`
  ${tw`block`}
  ${tw`w-fit`}
`;

const IconWrapperBase = styled.div`
  ${tw`flex items-center justify-center`}
  ${tw`w-[58px] h-[58px]`}
  ${tw`rounded-[8px]`}
`;

export const StyledLinkIconWrapper = styled(IconWrapperBase)`
  ${tw`bg-neutrals-n1`}
  box-shadow: 3px 3px 5px 0px rgba(18, 110, 211, 0.25), inset 0 0 0 1px #126ed3;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow:
      0 0 0 0 transparent,
      inset 0 0 0 1px #126ed3;
  }
`;

export const StyledIconWrapper = styled(IconWrapperBase)`
  ${tw`bg-ui-colours-ui1`}
  box-shadow: inset 0 0 0 1px #b7d3f2;
`;

export const StyledIcon = styled.img`
  ${tw`w-[42px]`}
  ${tw`h-[42px]`}
`;
